import { translator_handler } from '../../../handlers'
import { TIME } from '../../../services/util'

// import { TEMPLATE } from '../..'

const {
    deviceTranslator
} = translator_handler

const {
    parseDate
} = TIME

// const {
//     getAddress 
// } = map_handler

// const {
//     EVENT_TICKET_TYPES_BY_CODES
// } = TEMPLATE.STATUS

export const FORMATTER_TRIP = ({vids, tripRecords, vehicleGeoStateLogs, coordinates, vehicles, drivers}) => {
    const dataSrc = []

    vids.map(vid => {
        tripRecords.recordByVID[vid] 
        && tripRecords.recordByVID[vid].map(tr => {
            let new_tr = JSON.parse(JSON.stringify(tr))
            new_tr.geoIN = []
            new_tr.geoOUT = []

            const startTime = tr.startTime
            const endTime = tr.endTime
            
            const prevVGeoStateLogs = vehicleGeoStateLogs.logByVID[vid] && vehicleGeoStateLogs.logByVID[vid].filter(vl => vl.vehicleTime < startTime)
            const vGeoStateLogs = vehicleGeoStateLogs.logByVID[vid] && vehicleGeoStateLogs.logByVID[vid].filter(vl => vl.vehicleTime >= startTime && vl.vehicleTime <= endTime)

            if(prevVGeoStateLogs && prevVGeoStateLogs.length) {
                const prevVGeoStateLog = (prevVGeoStateLogs.sort((a, b) => b.vehicleTime - a.vehicleTime))[0]
                new_tr.geoIN = [ ...new_tr.geoIN, ...prevVGeoStateLog.geoIN]
            }
            
            if(vGeoStateLogs && vGeoStateLogs.length) {
                vGeoStateLogs.map(vl => {
                    new_tr.geoIN = [ ...new_tr.geoIN, ...vl.geoIN ]
                    new_tr.geoOUT = [ ...new_tr.geoOUT, ...vl.geoOUT ]
                })
            }

            new_tr.geoIN = new_tr.geoIN.filter((vid, pos, ary) => ary.indexOf(vid) === pos)
            new_tr.geoOUT = new_tr.geoOUT.filter((vid, pos, ary) => ary.indexOf(vid) === pos)

            const { lat: slat, lon: slon } = tr?.start_loc || {}
            const { lat: elat, lon: elon } = tr?.end_loc || {}

            new_tr.start_address = coordinates[`${slat},${slon}`] || '-'
            new_tr.end_address = coordinates[`${elat},${elon}`] || '-'

            new_tr.plate = vehicles[vid]?.plate || vid
            new_tr.driver = drivers[tr.drvid]?.name || tr.drvid


            dataSrc.push(new_tr)
        })
    })

    return dataSrc
    .filter(d => d.trid)
    .map((d, i) => ({key:i, ...d}))
    .sort((a, b) => a.vid - b.vid)
}

export const FORMATTER_TRANSIT = ({vids, transitRecords, vehicleGeoStateLogs, coordinates, vehicles, drivers}) => {
    const dataSrc = []

    vids.map(vid => {
        transitRecords.recordByVID[vid] 
        && transitRecords.recordByVID[vid].map(tr => {
            let new_tr = JSON.parse(JSON.stringify(tr))
            new_tr.geoIN = []
            new_tr.geoOUT = []

            const startTime = tr.startTime
            const endTime = tr.endTime
            
            const prevVGeoStateLogs = vehicleGeoStateLogs.logByVID[vid] && vehicleGeoStateLogs.logByVID[vid].filter(vl => vl.vehicleTime < startTime)
            const vGeoStateLogs = vehicleGeoStateLogs.logByVID[vid] && vehicleGeoStateLogs.logByVID[vid].filter(vl => vl.vehicleTime >= startTime && vl.vehicleTime <= endTime)

            if(prevVGeoStateLogs && prevVGeoStateLogs.length) {
                const prevVGeoStateLog = (prevVGeoStateLogs.sort((a, b) => b.vehicleTime - a.vehicleTime))[0]
                new_tr.geoIN = [ ...new_tr.geoIN, ...prevVGeoStateLog.geoIN]
            }
            
            if(vGeoStateLogs && vGeoStateLogs.length) {
                vGeoStateLogs.map(vl => {
                    new_tr.geoIN = [ ...new_tr.geoIN, ...vl.geoIN ]
                    new_tr.geoOUT = [ ...new_tr.geoOUT, ...vl.geoOUT ]
                })
            }

            new_tr.geoIN = new_tr.geoIN.filter((vid, pos, ary) => ary.indexOf(vid) === pos)
            new_tr.geoOUT = new_tr.geoOUT.filter((vid, pos, ary) => ary.indexOf(vid) === pos)

            const { lat: slat, lon: slon } = tr.start_loc || {}
            const { lat: elat, lon: elon } = tr.end_loc || {}
            
            new_tr.start_address = coordinates[`${slat},${slon}`] || '-'
            new_tr.end_address = coordinates[`${elat},${elon}`] || '-'
            new_tr.plate = vehicles[vid]?.plate || vid
            new_tr.driver = drivers[tr.drvid]?.name || tr.drvid
            
            dataSrc.push(new_tr)
        })
    })

    return dataSrc
    .map((d, i) => ({key:i, ...d}))
    .sort((a, b) => a.vid - b.vid)
}

export const FORMATTER_DETAIL = ({vids, vehicleLogs, vehicleDerivativeLogs, vehicleEventLogs, vehicleGeoStateLogs, vehicles }) => {
    const dataSrc = []

    vids.map(vid => {

        let accVHCLogs = {}

        if(
            vehicleLogs.logByVID[vid]
            &&
            vehicleDerivativeLogs.logByVID[vid]
        ) {

            vehicleLogs.logByVID[vid] && vehicleLogs.logByVID[vid].map(vl => accVHCLogs[vl.vehicleTime] = vl)
            vehicleDerivativeLogs.logByVID[vid] && vehicleDerivativeLogs.logByVID[vid].map(vl => accVHCLogs[vl.vehicleTime] = { ...accVHCLogs[vl.vehicleTime], ...vl })
            vehicleEventLogs.logByVID[vid] && vehicleEventLogs.logByVID[vid].map(vl => accVHCLogs[vl.vehicleTime] = { ...accVHCLogs[vl.vehicleTime], ...vl })


            Object.keys(accVHCLogs).map(vehicleTime => {

                let geoIN = []
                let geoOUT = []

                const prevVGeoStateLogs = vehicleGeoStateLogs.logByVID[vid] && vehicleGeoStateLogs.logByVID[vid].filter(vl => vl.vehicleTime < vehicleTime)
                const vGeoStateLog = vehicleGeoStateLogs.logByVID[vid] && vehicleGeoStateLogs.logByVID[vid].find(vl => vl.vehicleTime === vehicleTime)

                if(prevVGeoStateLogs && prevVGeoStateLogs.length) {
                    const prevVGeoStateLog = (prevVGeoStateLogs.sort((a, b) => b.vehicleTime - a.vehicleTime))[0]
                    geoIN = [ ...geoIN, ...prevVGeoStateLog.geoIN]

                    if(Object.keys(accVHCLogs).filter(t => t >= prevVGeoStateLog.vehicleTime &&  t<= vehicleTime).length < 3) {
                        geoOUT = [ ...geoOUT, ...prevVGeoStateLog.geoOUT]
                    }
                }

                if(vGeoStateLog) {
                    geoIN = [ ...geoIN, ...vGeoStateLog.geoIN]
                    geoOUT = [ ...geoOUT, ...vGeoStateLog.geoOUT]
                }

                accVHCLogs[vehicleTime] = { 
                    ...accVHCLogs[vehicleTime], 
                    plate: vehicles[vid]?.plate,
                    geoIN, 
                    geoOUT 
                }

                return null
            })
    
            Object.values(accVHCLogs).map(vl => dataSrc.push(vl))
        }

        return null
     })
 
    return dataSrc
    .map((d, i) => ({key:i, ...deviceTranslator(d)}))
    .sort((a, b) => a.vid - b.vid)
}

const sumAllData = (data = {}) => {
    const fpNum = data.FP_num || 0
    const result = {}
    
    if (fpNum === 0) return result;
    
    // Gunakan FP_0 sebagai template
    const template = data.FP_0_summary;
    
    Object.keys(template).forEach(category => {
        result[category] = { unit: template[category].unit };
        
        // Inisialisasi semua metric ke 0
        Object.keys(template[category]).forEach(metric => {
            if (metric !== 'unit') {
                result[category][metric] = 0;
            }
        });
        
        // Jumlahkan dari FP_0 sampai FP_{fpNum-1}
        for (let i = 0; i < fpNum; i++) {
            const summaryKey = `FP_${i}_summary`;
            Object.keys(template[category]).forEach(metric => {
                if (metric !== 'unit') {
                    result[category][metric] += data[summaryKey][category][metric];
                }
            });
        }
    });
    
    return result;
}

const sumAllDataFromArray = (dataArray = []) => {
    if (!dataArray.length) return {}

    return dataArray.reduce((acc, data) => {
        const result = sumAllData(data)
        
        if (!Object.keys(acc).length) return result

        Object.keys(result).forEach(category => {
            Object.keys(result[category]).forEach(metric => {
                if (metric !== 'unit') {
                    acc[category][metric] += result[category][metric]
                }
            })
        })

        return acc
    }, {})
}

export const FORMATTER_DAILY_SUMMARY = ({vids, vehicleReportDailySummaries, vehicles}) => {

    const dataSrc = []

    vids.map(vid => {

        const reports = vehicleReportDailySummaries.reportByVID[vid] || []

        
        reports.map(rds => {
            let new_rds = JSON.parse(JSON.stringify(rds))

            let capacity = 0

            for(let i = 0; i < rds.FP_num; i++) {
                capacity += rds[`FP_${i}_capacity`]
            }

            new_rds.plate = vehicles[vid]?.plate || vid
            new_rds.startTime = rds.reportTime
            new_rds.capacity = capacity
            new_rds.reportTime = parseDate(rds.reportTime)

            dataSrc.push({ ...new_rds, ...sumAllData(new_rds)})
        })

        return null
    })

    return dataSrc
    .map((d, i) => ({key:i, ...d}))
    .sort((a, b) => a.vid - b.vid)
}

export const FORMATTER_SUMMARY = ({vids, vehicleReportDailySummaries = {}, vehicles}) => {

    let data = {}

    vids.map((vid) => {

        const summaryByVID = vehicleReportDailySummaries.reportByVID[vid] || []

        const latestArr = summaryByVID.length - 1

        // const mergeByVehicleId = (data) => {
        //     const result = {};

        //     for (const [key, value = {}] of Object.entries(data)) {
        //         const parts = key.split('#');
        //         const vehicleId = parts.slice(0, 2).join('#');

        //         if (!result[vehicleId]) {

        //             result[vehicleId] = {
        //                 ...value,
        //                 refuels: [...(value.refuels || [])],
        //                 thefts: [...(value.thefts || [])],
        //                 geoIN: [...(value.geoIN || [])],
        //                 geoOUT: [...(value.geoOUT || [])],
        //             };

        //         } else {
        //             result[vehicleId].refuels.push(...value.refuels);
        //             result[vehicleId].thefts.push(...value.thefts);
        //             result[vehicleId].geoIN.push(...value.geoIN);
        //             result[vehicleId].geoOUT.push(...value.geoOUT);
        //             result[vehicleId].tripNumber += value.tripNumber;
        //             result[vehicleId].totalMovingDuration += value.totalMovingDuration;
        //             result[vehicleId].totalIdlingDuration += value.totalIdlingDuration;
        //         }
        //     }

        //     return result;
        // }

        // const summary = mergeByVehicleId(vehicleReportDailySummaries.objSummaries)
        const summary = vehicleReportDailySummaries.summary[vid]

        const sumHDLR = (param) => summaryByVID.reduce((sum, v) => sum + v[param], 0)

        console.log(summaryByVID.map(v => v.plat_daily_mileage))

        data[vid] = {
            vid: vid,
            plate: vehicles[vid]?.plate,
            reportTime: `${parseDate(summaryByVID[0]?.reportTime)} - ${parseDate(summaryByVID[latestArr]?.reportTime)}`,
            tripNumber: sumHDLR('tripNumber'),
            totalMovingDuration: sumHDLR('totalMovingDuration'),
            totalIdlingDuration: sumHDLR('totalIdlingDuration'),
            plat_daily_mileage: sumHDLR('plat_daily_mileage'),
            plat_daily_engine_hour: sumHDLR('plat_daily_engine_hour'),
            plat_hist_top_speed: summaryByVID[latestArr]?.plat_hist_top_speed,
            plat_hist_mileage: summaryByVID[latestArr]?.plat_hist_mileage,
            plat_hist_engine_hour: summaryByVID[latestArr]?.plat_hist_engine_hour,
            geoIN: summaryByVID.map(data => data.geoIN)?.flatMap(gin => gin),
            geoOUT: summaryByVID.map(data => data.geoOUT)?.flatMap(gout => gout),
            refuels: summaryByVID.map(data => data.refuel)?.flatMap(refuel => refuel),
            thefts: summaryByVID.map(data => data.theft)?.flatMap(theft => theft),
            // ...summaryByVID[0],
            ...sumAllDataFromArray(summaryByVID),
            ...summary
        }
        
        return null
     })

    return Object.values(data)
    .map((d, i) => ({key:i, ...d}))
    .sort((a, b) => a.vid - b.vid)
}

export const FORMATTER_GEOFENCE = ({vehicleReportGeofences, geoids, geofenceGroups, durations, vehicles, drivers}) => {

    const geoData = vehicleReportGeofences.byGEOID

    const dataSrc = Object.values(vehicleReportGeofences.recordByStartTime).map(geo => {

        const geoid = geo.geoid
        const geogroup = geofenceGroups[geoid]?.name || 'UNGROUP'
        const vid = geo.vid

        return {
            vid: vid,
            geoid,
            duration: geo.duration,
            startTime: geo.startTime,
            endTime: geo.endTime,
            name: geoData[geoid]?.name,
            group: geogroup,
            plate: vehicles[vid]?.plate,
            driver: drivers[geo.drvid]?.name
        }
    })

    return dataSrc
        .map((d, i) => ({ key: i, ...d }))
        .sort((a, b) => a.startTime - b.startTime)
        .filter(d => Array.isArray(geoids) && geoids.includes(d.geoid))
        .filter(d => durations !== 'All' ? d.duration > durations : d)
}

export const FORMATTER_REFUEL_REPORT = ({vehicleRefuel, filterPrice, vehicleFuelInfo, vehicles, drivers}) => {

    const dataSrc = []

    Object.keys(vehicleRefuel.reportByVID).map(vid => {

        const refuels = vehicleRefuel.reportByVID[vid]?.refuels || []

        const formatted = refuels.map(d => {

            const diff = d.endLog?.fuel - d.startLog?.fuel || 0
            const estPrice = filterPrice * diff || 0
            const startFuel = d.startLog?.fuel
            const endFuel = d.endLog?.fuel
            const location = d.startLog?.location
            const refuel = endFuel - startFuel
            const capacity = vehicleFuelInfo[vid]?.['0_capacity'] || 410
            const tank = vehicleFuelInfo[vid]?.tankNum || 1
            const plate = vehicles[vid]?.plate
            const driver = drivers[d.drvid]?.name
            
            return {
                vid,
                plate,
                driver,
                start_fuel_lvl: startFuel,
                end_fuel_lvl: endFuel,
                startTime: d.startLog?.vehicleTime, 
                endTime: d.endLog?.vehicleTime, 
                estPrice,
                refuel,
                address: d.startLog?.address,
                location,
                capacity, tank,
                // theft
            }
        })

        dataSrc.push(...formatted)
    })


    return dataSrc
        .map((d, i) => ({ key: i, ...d }))
        .sort((a, b) => a.vid - b.vid)
}

export const FORMATTER_EVENT = ({ vehicleEventLogs, vehicles, drivers }) => {

    const dataSrc = Object.values(vehicleEventLogs.logByVID)
    .flat()
    .map(v => {

        return {
            ...v,
            plate: vehicles[v.vid]?.plate || v.vid,
            driver: drivers[v.drvid]?.name || v.drvid,
            event_type: v?.rule?.type_rule || 0,
            event: v?.rule?.name || '-',
        }
    })
 
    return dataSrc
    .map((d, i) => ({ key:i, ...d }))
    .sort((a, b) => a.vid - b.vid)
}

export const FORMATTER_THEFT_REPORT = ({vehicleRefuel, filterPrice, vehicleFuelInfo, vehicles, drivers}) => {

    const dataSrc = []

    Object.keys(vehicleRefuel.reportByVID).map(vid => {

        const thefts = vehicleRefuel.reportByVID[vid]?.thefts || []

        const formatted = thefts.map(d => {

            const diff = d.startLog?.fuel - d.endLog?.fuel || 0
            const estPrice = filterPrice * diff || 0
            const startFuel = d.startLog?.fuel
            const endFuel = d.endLog?.fuel
            const location = d.startLog?.location
            const capacity = vehicleFuelInfo[vid]?.['0_capacity'] || 410
            const tank = vehicleFuelInfo[vid]?.tankNum || 1
            const theft = (startFuel > endFuel) && startFuel - endFuel || 0 
            const plate = vehicles[vid]?.plate
            const driver = drivers[d.drvid]?.name
            
            return {
                vid,
                start_fuel_lvl: startFuel,
                end_fuel_lvl: endFuel,
                startTime: d.startLog?.vehicleTime, 
                endTime: d.endLog?.vehicleTime, 
                estPrice,
                address: d.startLog?.address,
                location,
                capacity, tank, theft,
                plate,
                driver
            }
        })

        dataSrc.push(...formatted)
    })


    return dataSrc
        .map((d, i) => ({ key: i, ...d }))
        .sort((a, b) => a.vid - b.vid)
}

export const FORMATTER_UTILISATION = ({ vehicleUtilisation, vehicles, users }) => {

    const dataSrc = Object.values(vehicleUtilisation.reportByVID)
    .map(v => {

        const vid = v.vid

        return {
            ...v,
            plate: vehicles[vid]?.plate || vid,
            company: vehicles[vid]?.company || users[vehicles[vid]?.company]?.name,

        }
    })
 
    return dataSrc
    .map((d, i) => ({ key:i, ...d }))
    .sort((a, b) => a.vid - b.vid)
}

export const FORMATTER_MDVR_EVENT = ({ devicesMDVR, drivers }) => {

    const dataSrc = (Object.values(devicesMDVR.mdvrEventByID).flatMap(mdvrevent => mdvrevent) || [])
    .map(v => {

        const data = v.originalData || {}
        const fileExt = data.FileName?.split('.')[1]
        const type = fileExt === 'avi' ? 'Video' : 'Snapshot'
        const channelNum = data.FileName?.split('_')[9] || '-'
        const drvid = v.drvid || '-'

        return {
            ...v,
            location: {
                lat: data.Latitude,
                lon: data.Longitude
            },
            type: type,
            driver: drivers[drvid]?.name,
            channelNum: channelNum
        }
    })

    return dataSrc
    .map((d, i) => ({ key:i, ...d }))
    .sort((a, b) => a.vid - b.vid)
}

export const FORMATTER_DISCONNECTED = ({ devicesMDVR, vehicles }) => {

    const dataSrc = Object.values(devicesMDVR.disconnectedByID)
        ?.map(v => {
            return {
                ...v,
                plate: vehicles[v.vid]?.plate || v.vid,
                device: v.mdvrid,
                startTime: parseDate(v.startTime),
                endTime: parseDate(v.endTime)
                // in: v.FontGetInCount + v.BackGetInCount,
                // out: v.FontGetOffCount + v.BackGetOffCount,
                // total: v.TotalCount,
                // location: {
                //     lat: v.Lat,
                //     lon: v.Lng
                // },
                // driver: v.DriverName || '-',
                // time: v.chtime
            }
        })

    return dataSrc
    .map((d, i) => ({ key:i, ...d }))
    .sort((a, b) => a.vid - b.vid)
}

export const FORMATTER_PASSENGER_COUNT = ({ devicesMDVR, vehicles }) => {

    const dataSrc = (Object.values(devicesMDVR.passengerCountByID)?.flat()
        ?.flatMap(obj => obj.Data.map(d => ({ ...d, vid: obj.vid })))|| [])
        .map(v => {

            // const data = v.Data || []

            // const inCount = data.reduce((sum, { FontGetInCount = 0 }) => sum + FontGetInCount, 0) + data.reduce((sum, { BackGetInCount = 0 }) => sum + BackGetInCount, 0)
            // const outCount = data.reduce((sum, { FontGetOffCount = 0 }) => sum + FontGetOffCount, 0) + data.reduce((sum, { BackGetOffCount = 0 }) => sum + BackGetOffCount, 0)
            // const totalCount = data.reduce((sum, { TotalCount = 0 }) => sum + TotalCount, 0)

            return {
                ...v,
                plate: vehicles[v.vid]?.plate || v.vid,
                in: v.FontGetInCount + v.BackGetInCount,
                out: v.FontGetOffCount + v.BackGetOffCount,
                total: v.TotalCount,
                location: {
                    lat: v.Lat,
                    lon: v.Lng
                },
                driver: v.DriverName || '-',
                time: v.chtime
            }
        })

    return dataSrc
    .map((d, i) => ({ key:i, ...d }))
    .sort((a, b) => a.vid - b.vid)
}

